@for (itemPrice of priceDetail.Items; track itemPrice) {
  <div class="guest-price-summary respos-ft-light">
    <div class="guest-price-summary--label">{{itemPrice.Name}}</div>
    <div class="guest-price-summary--value">{{currency}}{{itemPrice.SubTotal | currencyDecimalFormatter}}</div>
  </div>
}
<div class="guest-price-summary__seperator"></div>
@for (labelMap of paymentSplitKeyLabels; track labelMap) {
  @if (priceDetail[labelMap.key]) {
    <div class="guest-price-summary respos-ft-light">
      <div class="guest-price-summary--label">{{labelMap.label | translate}}</div>
      <div class="guest-price-summary--value">{{currency}}{{priceDetail[labelMap.key] | currencyDecimalFormatter}}</div>
    </div>
  }
}
<div class="guest-price-summary__seperator"></div>
<div class="guest-price-summary respos-ft-light guest-price-summary--bold">
  <div class="guest-price-summary--label">{{'Total'}}</div>
  <div class="guest-price-summary--value">{{currency}}{{priceDetail.Total | currencyDecimalFormatter}}</div>
</div>